export default __webpack_public_path__ + "static/media/Adding a New Patient.24f5136e.pdf";